import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { PdlGateway } from '@cigna/pdl-viewer/shared/gateway-util';
import { FormularyEntity, FormularyRequest } from './formulary.models';

@Injectable({
  providedIn: 'root',
})
export class FormularyService {
  constructor(private _http: HttpClient, private _gw: PdlGateway) {}

  getFormularyDrugList(
    formularyRequest: FormularyRequest,
    isPublic: boolean,
  ): Observable<FormularyEntity> {
    return isPublic
      ? this._http.get<FormularyEntity>(
          this._gw.drugAndTypeAHeadPublicURL(formularyRequest),
        )
      : this._http.get<FormularyEntity>(
          this._gw.drugSearchURL(formularyRequest),
        );
  }
}
